export default __webpack_public_path__ + "static/media/PerryComo.cfd53d3e.mp3";